export enum ColumnName {
  Name = 'Name',
  Created = 'CREATED AT',
  LastModified = 'LAST MODIFIED AT',
}
